import { jsx as _jsx } from "preact/jsx-runtime";
import { h } from 'preact';
export default ({ currentDeviceId, audioSources, onChangeSource, }) => {
    return (_jsx("div", { className: "uppy-Audio-videoSource", children: _jsx("select", { className: "uppy-u-reset uppy-Audio-audioSource-select", onChange: (event) => {
                onChangeSource(event.target.value);
            }, children: audioSources.map((audioSource) => (_jsx("option", { value: audioSource.deviceId, selected: audioSource.deviceId === currentDeviceId, children: audioSource.label }, audioSource.deviceId))) }) }));
};
